import {StateLabel} from "@labels"
import {BasicOrganizationInfoFragment} from "@common/services/organizations/organizations.generated"
import {IsTruthy} from "@cm/utils/filter"

export const sortOrganizationsStateLabelListAlphabetically = (organizations: StateLabel<string>[]): StateLabel<string>[] => {
    return organizations.sort((a, b) => a.label.localeCompare(b.label))
}

export const sortOrganizationsDetailsWithNameAlphabetically = (organizationsDetails: BasicOrganizationInfoFragment[]): BasicOrganizationInfoFragment[] => {
    return [
        ...organizationsDetails.filter((organization) => IsTruthy(organization.name)).sort((a, b) => a.name!.localeCompare(b.name!)),
        ...organizationsDetails.filter((organization) => !IsTruthy(organization.name)),
    ]
}
